import { createContext, useContext, useEffect, useState } from "react";

const dict = {
  fr: {
    "nav.modules": "Modules",
    "nav.sectors": "Secteurs",
    "nav.pricing": "Tarifs",
    "nav.demo": "Démo",
    "nav.about": "À propos",
    "nav.blog": "Blog",
    "nav.faq": "FAQ",
    "nav.contact": "Contact",
    "nav.cta": "Demander l'accès",
    "footer.tagline": "Universal ERP & Business Management Platform.",
    "footer.slogan": "One platform. Every business.",
    "footer.platform": "Plateforme",
    "footer.company": "Entreprise",
    "footer.legal": "Pages légales",
    "footer.follow": "Suivez-nous",
    "footer.rights": "Tous droits réservés.",
    "footer.updated": "Mis à jour le",
    "common.loading": "Chargement…",
    "common.error": "Une erreur est survenue. Veuillez réessayer.",
    "common.retry": "Réessayer",
    "common.empty": "Aucun contenu disponible pour le moment.",
    "common.viewAll": "Tout voir",
    "common.learnMore": "En savoir plus",
    "home.heroEyebrow": "ERP universel tout-en-un",
    "home.heroA": "One platform.",
    "home.heroB": "Every business.",
    "home.heroSub":
      "Pilotez ventes, finances, RH, projets et modules métiers depuis une seule plateforme. Moins d'outils, moins de ressaisies, plus de visibilité pour les entreprises de toutes tailles et de tous secteurs.",
    "home.ctaDemo": "Demander une démo",
    "home.ctaModules": "Découvrir les modules",
    "home.statModules": "modules disponibles",
    "home.statSectors": "secteurs couverts",
    "home.statTrial": "jours d'essai",
    "home.pillarsEyebrow": "Pourquoi MANAGONE",
    "home.pillarsTitle": "Une plateforme, quatre fondations",
    "home.pillarsSub": "Tout ce qu'il faut pour piloter votre entreprise, sans jongler entre dix outils.",
    "home.pillars": [
      { icon: "Layers", title: "Tout-en-un", desc: "Ventes, stocks, finances, RH, projets : chaque fonction de l'entreprise dans le même environnement." },
      { icon: "Puzzle", title: "Modulaire par design", desc: "Activez uniquement les modules dont vous avez besoin, puis étendez au rythme de votre croissance." },
      { icon: "ShieldCheck", title: "Sécurité & isolation", desc: "Chaque entreprise dispose de son propre espace cloisonné, avec des contrôles côté serveur." },
      { icon: "Globe2", title: "Bilingue & multi-devises", desc: "Français et anglais natifs, référentiels comptables SYSCOHADA et IFRS, multi-devises." },
    ],
    "home.sectorsEyebrow": "Explorateur de secteurs",
    "home.sectorsTitle": "Un ERP qui parle votre métier",
    "home.sectorsSub": "Sélectionnez votre secteur et découvrez les modules recommandés pour votre activité.",
    "home.recommended": "Modules recommandés",
    "home.howEyebrow": "Mise en route",
    "home.howTitle": "Opérationnel en quatre étapes",
    "home.steps": [
      { title: "Démo & découverte", desc: "Un échange avec notre équipe pour comprendre vos besoins et vos priorités." },
      { title: "Configuration", desc: "Activation des modules, référentiels comptables et paramètres de votre entreprise." },
      { title: "Formation", desc: "Prise en main guidée pour vos équipes, rôle par rôle." },
      { title: "Lancement", desc: "Bascule en production accompagnée, avec support dédié." },
    ],
    "home.spacesTitle": "Quatre espaces, une seule plateforme",
    "home.spaces": [
      { icon: "Building2", title: "Espace entreprise", desc: "Le cœur opérationnel : tous vos modules, vos données et vos équipes." },
      { icon: "Settings2", title: "Console d'administration", desc: "Utilisateurs, rôles, modules et paramètres globaux sous contrôle." },
      { icon: "DoorOpen", title: "Portail client", desc: "Devis, factures et suivi accessibles à vos clients en libre-service." },
      { icon: "UserRound", title: "Portail employé", desc: "Congés, bulletins et demandes pour chaque collaborateur." },
    ],
    "home.aiEyebrow": "MANAGONE AI",
    "home.aiTitle": "L'intelligence artificielle au service de votre gestion",
    "home.aiSub": "MANAGONE AI analyse vos données en continu pour vous aider à décider plus vite.",
    "home.aiPoints": [
      "Prévisions de ventes et de trésorerie à partir de votre historique",
      "Détection d'anomalies sur les stocks, les achats et la facturation",
      "Assistant en langage naturel pour interroger vos indicateurs",
    ],
    "home.aiCta": "Découvrir MANAGONE AI",
    "modules.eyebrow": "Catalogue",
    "modules.title": "Les modules MANAGONE",
    "modules.sub": "Des modules généraux pour chaque entreprise, et des modules métiers adaptés à votre secteur.",
    "modules.general": "Modules généraux",
    "modules.sector": "Modules métiers",
    "modules.count": "modules",
    "sectors.eyebrow": "Secteurs",
    "sectors.title": "Pensé pour votre secteur",
    "sectors.sub": "MANAGONE s'adapte à votre métier avec des modules dédiés et des parcours recommandés.",
    "sectors.recommended": "modules recommandés",
    "pricing.eyebrow": "Tarifs",
    "pricing.title": "Une offre adaptée à chaque entreprise",
    "pricing.sub": "Commencez petit, grandissez sans changer d'outil. Chaque offre démarre par un essai gratuit.",
    "pricing.monthly": "Mensuel",
    "pricing.annual": "Annuel",
    "pricing.perMonth": "/mois",
    "pricing.perYear": "/an",
    "pricing.perUser": "/utilisateur/mois",
    "pricing.custom": "Sur devis",
    "pricing.usersUpTo": "Jusqu'à {n} utilisateurs",
    "pricing.usersUnlimited": "Utilisateurs illimités",
    "pricing.allModules": "Tous les modules inclus",
    "pricing.modulesIncluded": "{n} modules inclus",
    "pricing.sectorYes": "Modules métiers inclus",
    "pricing.sectorNo": "Modules métiers en option",
    "pricing.trial": "{n} jours d'essai gratuit",
    "pricing.choose": "Choisir cette offre",
    "pricing.contact": "Nous contacter",
    "pricing.recommended": "Recommandé",
    "pricing.compareTitle": "Comparer les offres",
    "pricing.f.priceM": "Prix mensuel",
    "pricing.f.priceA": "Prix annuel",
    "pricing.f.users": "Utilisateurs",
    "pricing.f.modules": "Modules généraux",
    "pricing.f.sector": "Modules métiers",
    "pricing.f.trial": "Essai gratuit",
    "pricing.all": "Tous",
    "pricing.included": "Inclus",
    "pricing.optional": "En option",
    "pricing.days": "{n} jours",
    "pricing.unlimited": "Illimité",
    "demo.eyebrow": "Démonstration",
    "demo.title": "Demander une démo",
    "demo.sub": "Racontez-nous votre activité : notre équipe vous recontacte pour organiser une démonstration personnalisée.",
    "contact.eyebrow": "Contact",
    "contact.title": "Parlons de votre projet",
    "contact.sub": "Une question, un besoin précis, une demande d'accès ? Écrivez-nous, nous répondons rapidement.",
    "form.name": "Nom complet",
    "form.email": "E-mail professionnel",
    "form.company": "Entreprise",
    "form.phone": "Téléphone",
    "form.country": "Pays",
    "form.sector": "Secteur d'activité",
    "form.sectorOther": "Autre",
    "form.companySize": "Taille de l'entreprise",
    "form.preferredDate": "Date souhaitée",
    "form.subject": "Objet",
    "form.message": "Message",
    "form.required": "obligatoire",
    "form.submit": "Envoyer la demande",
    "form.submitContact": "Envoyer le message",
    "form.sending": "Envoi en cours…",
    "form.successTitle": "Demande envoyée !",
    "form.successDemo": "Merci pour votre intérêt. Notre équipe vous contactera très vite pour planifier votre démonstration.",
    "form.successContact": "Merci pour votre message. Notre équipe reviendra vers vous dans les plus brefs délais.",
    "form.backHome": "Retour à l'accueil",
    "form.newRequest": "Envoyer une autre demande",
    "form.selectPlaceholder": "Sélectionnez…",
    "form.sizes": ["1 – 10 employés", "11 – 50 employés", "51 – 200 employés", "Plus de 200 employés"],
    "about.eyebrow": "À propos",
    "about.title": "Une plateforme née d'une conviction",
    "about.intro":
      "MANAGONE est née d'une conviction simple : chaque entreprise, quelle que soit sa taille ou son secteur, mérite des outils de gestion à la hauteur de ses ambitions.",
    "about.missionTitle": "Notre mission",
    "about.mission":
      "Réunir dans une seule plateforme tout ce qu'il faut pour gérer une entreprise — du premier devis à la paie, du stock à la comptabilité — sans complexité inutile et sans barrière de langue.",
    "about.valuesTitle": "Nos valeurs",
    "about.values": [
      { icon: "Compass", title: "Simplicité", desc: "Des parcours clairs et des écrans qui vont à l'essentiel." },
      { icon: "Handshake", title: "Proximité", desc: "Une équipe qui accompagne chaque client, de la démo au quotidien." },
      { icon: "ShieldCheck", title: "Confiance", desc: "Des données cloisonnées, protégées et vérifiables à tout moment." },
      { icon: "Rocket", title: "Progression", desc: "Une plateforme qui grandit avec vous, module après module." },
    ],
    "about.teamTitle": "Une équipe au service de votre réussite",
    "about.teamText":
      "Consultants, développeurs et experts métiers travaillent main dans la main pour faire de MANAGONE le copilote de votre entreprise.",
    "about.cta": "Rencontrer l'équipe",
    "blog.eyebrow": "Blog",
    "blog.title": "Actualités & ressources",
    "blog.sub": "Conseils de gestion, nouveautés produit et retours d'expérience.",
    "blog.empty": "Aucun article publié pour le moment. Revenez bientôt !",
    "blog.readMore": "Lire l'article",
    "blog.back": "Retour au blog",
    "blog.notFound": "Cet article est introuvable.",
    "blog.published": "Publié le",
    "faq.eyebrow": "FAQ",
    "faq.title": "Questions fréquentes",
    "faq.sub": "Tout ce qu'il faut savoir avant de démarrer avec MANAGONE.",
    "faq.empty": "Aucune question publiée pour le moment.",
    "faq.stillQuestions": "Une autre question ?",
    "faq.contactUs": "Contactez-nous",
    "legal.notFound": "Cette page est introuvable.",
    "legal.updated": "Dernière mise à jour le",
    "notFound.title": "Page introuvable",
    "notFound.sub": "La page que vous cherchez n'existe pas ou a été déplacée.",
    "cta.trustTrial": "{n} jours d'essai gratuit",
    "cta.trustItems": ["Démo personnalisée", "Accompagnement dédié", "Bilingue FR / EN"],
    "cta.benefits": [
      { icon: "Layers", title: "Un seul outil au lieu de dix", desc: "Ventes, stocks, finances et RH réunis : fini les ressaisies et les fichiers dispersés." },
      { icon: "LineChart", title: "Des décisions plus rapides", desc: "Vos indicateurs clés à jour en temps réel, partout et pour chaque équipe." },
      { icon: "TrendingUp", title: "Une plateforme qui suit votre croissance", desc: "Démarrez avec l'essentiel, activez de nouveaux modules quand vous en avez besoin." },
    ],
    "cta.finalEyebrow": "Passez à l'action",
    "cta.finalTitle": "Prêt à transformer la gestion de votre entreprise ?",
    "cta.finalSub":
      "Découvrez en une démo comment MANAGONE centralise vos opérations et fait gagner du temps à vos équipes dès les premières semaines.",
    "cta.finalPrimary": "Demander une démo",
    "cta.finalSecondary": "Voir les tarifs",
    "cta.stickyText": "Une plateforme pour toute votre entreprise",
    "cta.heroBadge": "modules dans une seule plateforme",
  },
  en: {
    "nav.modules": "Modules",
    "nav.sectors": "Industries",
    "nav.pricing": "Pricing",
    "nav.demo": "Demo",
    "nav.about": "About",
    "nav.blog": "Blog",
    "nav.faq": "FAQ",
    "nav.contact": "Contact",
    "nav.cta": "Request access",
    "footer.tagline": "Universal ERP & Business Management Platform.",
    "footer.slogan": "One platform. Every business.",
    "footer.platform": "Platform",
    "footer.company": "Company",
    "footer.legal": "Legal pages",
    "footer.follow": "Follow us",
    "footer.rights": "All rights reserved.",
    "footer.updated": "Updated on",
    "common.loading": "Loading…",
    "common.error": "Something went wrong. Please try again.",
    "common.retry": "Retry",
    "common.empty": "No content available yet.",
    "common.viewAll": "View all",
    "common.learnMore": "Learn more",
    "home.heroEyebrow": "All-in-one universal ERP",
    "home.heroA": "One platform.",
    "home.heroB": "Every business.",
    "home.heroSub":
      "Manage sales, finance, HR, projects and industry modules from a single platform. Fewer tools, less re-keying, more visibility for companies of every size and every industry.",
    "home.ctaDemo": "Request a demo",
    "home.ctaModules": "Explore the modules",
    "home.statModules": "modules available",
    "home.statSectors": "industries covered",
    "home.statTrial": "trial days",
    "home.pillarsEyebrow": "Why MANAGONE",
    "home.pillarsTitle": "One platform, four foundations",
    "home.pillarsSub": "Everything you need to run your business, without juggling ten different tools.",
    "home.pillars": [
      { icon: "Layers", title: "All-in-one", desc: "Sales, inventory, finance, HR, projects: every business function in the same environment." },
      { icon: "Puzzle", title: "Modular by design", desc: "Enable only the modules you need, then expand at the pace of your growth." },
      { icon: "ShieldCheck", title: "Security & isolation", desc: "Each company gets its own partitioned workspace, with server-side checks." },
      { icon: "Globe2", title: "Bilingual & multi-currency", desc: "Native French and English, SYSCOHADA and IFRS ledgers, multi-currency." },
    ],
    "home.sectorsEyebrow": "Industry explorer",
    "home.sectorsTitle": "An ERP that speaks your trade",
    "home.sectorsSub": "Pick your industry and discover the modules recommended for your business.",
    "home.recommended": "Recommended modules",
    "home.howEyebrow": "Getting started",
    "home.howTitle": "Up and running in four steps",
    "home.steps": [
      { title: "Demo & discovery", desc: "A conversation with our team to understand your needs and priorities." },
      { title: "Configuration", desc: "Modules, accounting standards and company settings switched on." },
      { title: "Training", desc: "Guided onboarding for your teams, role by role." },
      { title: "Go-live", desc: "A supported move to production, with dedicated support." },
    ],
    "home.spacesTitle": "Four spaces, one platform",
    "home.spaces": [
      { icon: "Building2", title: "Company workspace", desc: "The operational core: all your modules, data and teams." },
      { icon: "Settings2", title: "Admin console", desc: "Users, roles, modules and global settings under control." },
      { icon: "DoorOpen", title: "Customer portal", desc: "Quotes, invoices and tracking available to your customers, self-service." },
      { icon: "UserRound", title: "Employee portal", desc: "Leave, payslips and requests for every team member." },
    ],
    "home.aiEyebrow": "MANAGONE AI",
    "home.aiTitle": "Artificial intelligence at the service of your management",
    "home.aiSub": "MANAGONE AI continuously analyses your data to help you decide faster.",
    "home.aiPoints": [
      "Sales and cash-flow forecasts built from your history",
      "Anomaly detection across inventory, purchasing and billing",
      "A natural-language assistant to query your KPIs",
    ],
    "home.aiCta": "Discover MANAGONE AI",
    "modules.eyebrow": "Catalogue",
    "modules.title": "MANAGONE modules",
    "modules.sub": "General modules for every company, and industry modules tailored to your sector.",
    "modules.general": "General modules",
    "modules.sector": "Industry modules",
    "modules.count": "modules",
    "sectors.eyebrow": "Industries",
    "sectors.title": "Built for your industry",
    "sectors.sub": "MANAGONE adapts to your trade with dedicated modules and recommended journeys.",
    "sectors.recommended": "recommended modules",
    "pricing.eyebrow": "Pricing",
    "pricing.title": "A plan for every company",
    "pricing.sub": "Start small, grow without switching tools. Every plan starts with a free trial.",
    "pricing.monthly": "Monthly",
    "pricing.annual": "Annual",
    "pricing.perMonth": "/month",
    "pricing.perYear": "/year",
    "pricing.perUser": "/user/month",
    "pricing.custom": "Custom quote",
    "pricing.usersUpTo": "Up to {n} users",
    "pricing.usersUnlimited": "Unlimited users",
    "pricing.allModules": "All modules included",
    "pricing.modulesIncluded": "{n} modules included",
    "pricing.sectorYes": "Industry modules included",
    "pricing.sectorNo": "Industry modules optional",
    "pricing.trial": "{n}-day free trial",
    "pricing.choose": "Choose this plan",
    "pricing.contact": "Contact us",
    "pricing.recommended": "Recommended",
    "pricing.compareTitle": "Compare plans",
    "pricing.f.priceM": "Monthly price",
    "pricing.f.priceA": "Annual price",
    "pricing.f.users": "Users",
    "pricing.f.modules": "General modules",
    "pricing.f.sector": "Industry modules",
    "pricing.f.trial": "Free trial",
    "pricing.all": "All",
    "pricing.included": "Included",
    "pricing.optional": "Optional",
    "pricing.days": "{n} days",
    "pricing.unlimited": "Unlimited",
    "demo.eyebrow": "Demo",
    "demo.title": "Request a demo",
    "demo.sub": "Tell us about your business: our team will get back to you to arrange a personalised demonstration.",
    "contact.eyebrow": "Contact",
    "contact.title": "Let's talk about your project",
    "contact.sub": "A question, a specific need, an access request? Write to us — we reply quickly.",
    "form.name": "Full name",
    "form.email": "Work email",
    "form.company": "Company",
    "form.phone": "Phone",
    "form.country": "Country",
    "form.sector": "Industry",
    "form.sectorOther": "Other",
    "form.companySize": "Company size",
    "form.preferredDate": "Preferred date",
    "form.subject": "Subject",
    "form.message": "Message",
    "form.required": "required",
    "form.submit": "Send request",
    "form.submitContact": "Send message",
    "form.sending": "Sending…",
    "form.successTitle": "Request sent!",
    "form.successDemo": "Thank you for your interest. Our team will contact you very soon to schedule your demo.",
    "form.successContact": "Thank you for your message. Our team will get back to you as soon as possible.",
    "form.backHome": "Back to home",
    "form.newRequest": "Send another request",
    "form.selectPlaceholder": "Select…",
    "form.sizes": ["1 – 10 employees", "11 – 50 employees", "51 – 200 employees", "200+ employees"],
    "about.eyebrow": "About",
    "about.title": "A platform born from a conviction",
    "about.intro":
      "MANAGONE was born from a simple conviction: every company, whatever its size or industry, deserves management tools that match its ambitions.",
    "about.missionTitle": "Our mission",
    "about.mission":
      "To bring into a single platform everything it takes to run a company — from the first quote to payroll, from stock to accounting — without unnecessary complexity and without language barriers.",
    "about.valuesTitle": "Our values",
    "about.values": [
      { icon: "Compass", title: "Simplicity", desc: "Clear journeys and screens that get straight to the point." },
      { icon: "Handshake", title: "Closeness", desc: "A team that supports every customer, from demo to daily work." },
      { icon: "ShieldCheck", title: "Trust", desc: "Data that is partitioned, protected and verifiable at any time." },
      { icon: "Rocket", title: "Progress", desc: "A platform that grows with you, module after module." },
    ],
    "about.teamTitle": "A team dedicated to your success",
    "about.teamText":
      "Consultants, developers and industry experts work hand in hand to make MANAGONE your company's co-pilot.",
    "about.cta": "Meet the team",
    "blog.eyebrow": "Blog",
    "blog.title": "News & resources",
    "blog.sub": "Management advice, product updates and customer stories.",
    "blog.empty": "No articles published yet. Come back soon!",
    "blog.readMore": "Read article",
    "blog.back": "Back to blog",
    "blog.notFound": "This article could not be found.",
    "blog.published": "Published on",
    "faq.eyebrow": "FAQ",
    "faq.title": "Frequently asked questions",
    "faq.sub": "Everything you need to know before starting with MANAGONE.",
    "faq.empty": "No questions published yet.",
    "faq.stillQuestions": "Another question?",
    "faq.contactUs": "Contact us",
    "legal.notFound": "This page could not be found.",
    "legal.updated": "Last updated on",
    "notFound.title": "Page not found",
    "notFound.sub": "The page you are looking for does not exist or has moved.",
    "cta.trustTrial": "{n}-day free trial",
    "cta.trustItems": ["Personalised demo", "Dedicated onboarding", "Bilingual FR / EN"],
    "cta.benefits": [
      { icon: "Layers", title: "One tool instead of ten", desc: "Sales, inventory, finance and HR together: no more double entry or scattered spreadsheets." },
      { icon: "LineChart", title: "Faster decisions", desc: "Your key metrics updated in real time, anywhere, for every team." },
      { icon: "TrendingUp", title: "A platform that grows with you", desc: "Start with the essentials, switch on new modules whenever you need them." },
    ],
    "cta.finalEyebrow": "Take the next step",
    "cta.finalTitle": "Ready to transform how you run your business?",
    "cta.finalSub":
      "See in one demo how MANAGONE centralises your operations and saves your teams time from the very first weeks.",
    "cta.finalPrimary": "Request a demo",
    "cta.finalSecondary": "See pricing",
    "cta.stickyText": "One platform for your whole business",
    "cta.heroBadge": "modules in a single platform",
  },
};

const LangCtx = createContext(null);

export function LanguageProvider({ children }) {
  const [lang, setLang] = useState(() => localStorage.getItem("mg-lang") || "fr");
  useEffect(() => {
    localStorage.setItem("mg-lang", lang);
    document.documentElement.lang = lang;
  }, [lang]);
  const t = (key, vars) => {
    let val = dict[lang][key] ?? dict.fr[key] ?? key;
    if (vars && typeof val === "string") {
      Object.entries(vars).forEach(([k, v]) => {
        val = val.replace(`{${k}}`, v);
      });
    }
    return val;
  };
  return <LangCtx.Provider value={{ lang, setLang, t }}>{children}</LangCtx.Provider>;
}

export function useLang() {
  return useContext(LangCtx);
}
